import { render, staticRenderFns } from "./CompaniesTable.vue?vue&type=template&id=897f2970&scoped=true&"
import script from "./CompaniesTable.vue?vue&type=script&lang=js&"
export * from "./CompaniesTable.vue?vue&type=script&lang=js&"
import style0 from "./CompaniesTable.vue?vue&type=style&index=0&id=897f2970&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "897f2970",
  null
  
)

export default component.exports